import { Close as CloseIcon, Search as SearchIcon } from '@mui/icons-material';
import { Box, IconButton, InputAdornment, Paper, TextField, Typography } from '@mui/material';
import { ChangeEvent, memo } from 'react';

type Props = {
  title: string;
  filter: string;
  totalCount: number;
  onFilterChange: (value: string) => void;
};

export const ReactionsFilters = memo(({ title, filter, totalCount, onFilterChange }: Props) => {
  const handleFilterChange = (e: ChangeEvent<HTMLInputElement>) => {
    onFilterChange(e.target.value);
  };

  const handleClearFilter = () => {
    onFilterChange('');
  };

  return (
    <Paper sx={{ mb: 2 }}>
      <Box display="flex" alignItems="center" p="8px 16px" gap={2} flexWrap="wrap">
        <Typography variant="h6" sx={{ minWidth: 'fit-content' }}>
          {title}
        </Typography>

        <Box display="flex" alignItems="center" gap={2} flex={1} minWidth="300px">
          <TextField
            sx={{ minWidth: '350px', maxWidth: '500px', flex: 1 }}
            placeholder="Search by code, Russian or English name..."
            size="small"
            value={filter}
            onChange={handleFilterChange}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
              endAdornment: filter && (
                <IconButton size="small" onClick={handleClearFilter}>
                  <CloseIcon fontSize="small" />
                </IconButton>
              ),
            }}
          />
        </Box>

        <Typography variant="body2" color="text.secondary" sx={{ minWidth: 'fit-content' }}>
          {totalCount} {totalCount === 1 ? 'reaction' : 'reactions'}
        </Typography>
      </Box>
    </Paper>
  );
});

ReactionsFilters.displayName = 'ReactionsFilters';
